import type { CardImageProps } from '@/components/control/components/card-image/card-image.types';
import Control from '@/components/control';
import useChoice from '@/components/control/hooks/useChoice';
import { choiceId } from '@/components/control/utils';
import '@/components/control/components/card-image/card-image.css';
import { useDebounceCallback, useMediaQuery, useResizeObserver } from 'usehooks-ts';
import { useRef, useState } from 'react';

type Size = {
  width?: number;
  height?: number;
};

export default function CardImage(props: CardImageProps) {
  const { type, onChange } = useChoice(props.value, props.id, props.onChange);
  const isCardsSize = useMediaQuery('(min-width: 548px)');

  return (
    <div className='control-card-image'>
      {props.choices.map((choice, index, choices) => {
        const id = choiceId(props.id, choice.value, index);
        return (
          <Control.RadioLabel
            key={id}
            id={id}
            value={props.value}
            state={props.state || 'idle'}
            choice={choice}
            choices={choices}
          >
            {({ focused, hovered, checked, state }) => (
              <Control.Box state={state} checked={checked} focused={focused}>
                <div className='control-card-image__content'>
                  <Control.HiddenInput
                    type={type}
                    id={id}
                    name={props.id}
                    value={choice.value}
                    checked={checked}
                    disabled={props.disabled}
                    onChange={() => onChange(choice.value)}
                  />
                  <div className='control-card-image__top'>
                    <div
                      data-image={choice.icon}
                      style={{ backgroundImage: `url(${props.sprite})` }}
                      className='control-card-image__image'
                    />
                  </div>
                  <div className='control-card-image__bottom'>
                    <div>
                      <Control.Choice
                        type={type}
                        state={state}
                        checked={checked}
                        focused={focused}
                        hovered={hovered}
                        disabled={props.disabled}
                      />
                    </div>
                    <div className='control-card-image__mobile'>
                      <div
                        data-image={choice.icon}
                        style={{ backgroundImage: `url(${props.spriteMobile})` }}
                        className='control-card-image__mobile-image'
                      />
                    </div>
                    <div className='control-card-image__text'>
                      <Control.RadioText size={isCardsSize ? 'md' : 'lg'} checked={checked}>
                        {choice.label}
                      </Control.RadioText>
                    </div>
                  </div>
                </div>
              </Control.Box>
            )}
          </Control.RadioLabel>
        );
      })}
    </div>
  );
}
